<template>
  <div id="app">
    <NavbarView />
    <router-view v-slot="{ Component }">
      <transition name="page-fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
    <FooterView />
  </div>
</template>

<script>
import NavbarView from "./components/NavbarView.vue";
import FooterView from "./components/FooterView.vue";

export default {
  name: "App",
  components: { NavbarView, FooterView },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Black+Ops+One&family=Rajdhani:wght@400;600;700&family=Cairo:wght@400;600;700;900&display=swap");

*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --red: #cc0000;
  --red-glow: #ff2020;
  --red-dark: #8b0000;
  --black: #050505;
  --dark: #0d0d0d;
  --dark2: #111111;
  --steel: #1a1a1a;
  --white: #f0f0f0;
  --grey: #888;
  --gold: #c9a84c;
}

html {
  scroll-behavior: smooth;
  overflow-x: hidden;
}

body {
  margin: 0;
  background: var(--black);
  color: var(--white);
  font-family: "Cairo", sans-serif;
  overflow-x: hidden;
}

::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-track {
  background: var(--black);
}
::-webkit-scrollbar-thumb {
  background: var(--red);
  border-radius: 3px;
}
::-webkit-scrollbar-thumb:hover {
  background: var(--red-glow);
}

::selection {
  background: var(--red);
  color: #fff;
}

.page-fade-enter-active,
.page-fade-leave-active {
  transition: opacity 0.35s ease, transform 0.35s ease;
}
.page-fade-enter-from {
  opacity: 0;
  transform: translateY(12px);
}
.page-fade-leave-to {
  opacity: 0;
  transform: translateY(-12px);
}
</style>
